import { AssignmentActionTypes } from "./assignment.types";

const INITAIL_STATE = {
  //questionList
  questionList: [],
};

const assignmentReducer = (state = INITAIL_STATE, action) => {
  switch (action.type) {
    case AssignmentActionTypes.SET_QUESTION_LIST:
      let questionsList = [...action.payload];
      questionsList.sort(function (a, b) {
        return a.orders - b.orders;
      });
      return {
        ...state,
        questionList: questionsList,
      };
    case AssignmentActionTypes.ADD_QUESTION:
      let question = action.payload.question;
      let questionIndex = action.payload.index;
      let questions = state.questionList;
      let questionList = [];
      if (questionIndex !== undefined) {
        // if (question.id) {
        //   questionList = [
        //     ...questions.slice(0, questionIndex),
        //     question,
        //     ...questions.slice(questionIndex + 1, questions.length),
        //   ];
        // } else {
        //   questionList = [
        //     ...questions.slice(0, questionIndex),
        //     question,
        //     ...questions.slice(questionIndex + 1, questions.length),
        //     {},
        //   ];
        // }
        questionList = [
          ...questions.slice(0, questionIndex),
          question,
          ...questions.slice(questionIndex + 1, questions.length),
        ];
      } else {
        questionList = [...questions, question];
      }
      return {
        ...state,
        questionList: questionList,
      };

    case AssignmentActionTypes.EDIT_QUESTION:
      let allQuestions = [];
      allQuestions = [
        ...state.questionList.slice(0, action.payload.index),
        action.payload.question,
        ...state.questionList.slice(
          action.payload.index + 1,
          state.questionList.length
        ),
      ];
      return {
        ...state,
        questionList: allQuestions,
      };
    case AssignmentActionTypes.DELETE_QUESTION:
      const listQuestion = state.questionList.filter(
        (question, index) => index !== action.payload
      );
      return {
        ...state,
        questionList: listQuestion,
      };

    default:
      return state;
  }
};

export default assignmentReducer;
